import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/axiosInstance";
import { useParams } from "react-router-dom";
import {
  Checkbox,
  List,
  Spin,
  Button,
  message,
  Flex,
  Tag,
  Card,
  Typography,
  Modal,
} from "antd";
import orderService from "../../services/OrderLists";
import MarkAsCompleteFlTask from "./MarkAsCompleteFlTask";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";

const { Title } = Typography;

function MarkAsComplete({ setIsModalVisible }) {
  const { orderKey } = useParams();
  const userType = useSelector(
    (state) => state.auth.user?.user?.type || state.auth.user?.type
  );
  console.log("User Type:", userType);

  const [dataSource, setDataSource] = useState([]);
  const [majorminorReport, setMajorminorReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [showAcknowledgementModal, setShowAcknowledgementModal] =
    useState(false);
  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const ismobile = useMediaQuery({ query: "(max-width: 768px)" });

  const fetchSubscribersList = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `task/v2/task-subscribers-list/${orderKey}/`
      );
      const res2 = await axiosInstance.get(
        `task/v2/reference-report/${orderKey}/`
      );
      const data = res?.data?.data || [];
      setDataSource(data);
      setMajorminorReport(res2?.data?.data || []);
    } catch (err) {
      // This list is only used to populate an optional subscriber checklist;
      // a permission gap here shouldn't surface a scary "Permission denied"
      // toast for an action (Mark as Complete) the user is otherwise allowed to do.
      console.error("Failed to load subscriber list / reference report:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscribersList();
  }, [orderKey]);

  const handleUserSelect = (uuid) => {
    setSelectedUsers((prev) => {
      if (prev.includes(uuid)) {
        return prev.filter((id) => id !== uuid);
      } else {
        return [...prev, uuid];
      }
    });
  };

  const handleSubmitClick = () => {
    if (userType === 2) {
      setShowAcknowledgementModal(true);
      setIsAcknowledged(false);
    } else {
      handleSubmit();
    }
  };

  const handleAcknowledgementSubmit = () => {
    if (!isAcknowledged) {
      message.warning("Please acknowledge the declaration to proceed.");
      return;
    }
    setShowAcknowledgementModal(false);
    handleSubmit();
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitLoading(true);
      const selectedUsernames = dataSource
        .filter((item) => selectedUsers.includes(item.uuid))
        .map((item) => item.username);

      const response = await orderService.markAsComplete(orderKey, {
        subscribers: selectedUsernames,
      });

      if (response.success) {
        setIsSubmitLoading(false);

        message.success("Successfully marked as Complete");
        setIsModalVisible(false);
      } else {
        setIsSubmitLoading(false);
        // message.error("Failed to mark as verified");
      }
    } catch (err) {
      setIsSubmitLoading(false);

      message.error("An error occurred");
      console.error(err);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  const MyComponent = ({ majorminorReport }) => {
    return (
      <>
        {majorminorReport?.visible && (
          <Card
            style={{
              backgroundColor: "#fff4e5",
              border: "1px solid #ffa940",
              borderRadius: "10px",
              width: "100%",
            }}
          >
            <Flex
              justify={ismobile ? "center" : "space-between"}
              align="center"
              style={{
                width: "100%",
                flexDirection: ismobile ? "column" : "row",
                textAlign: ismobile ? "center" : "left",
                gap: ismobile ? "10px" : "0",
              }}
            >
              <Title level={5} style={{ color: "#d46b08", margin: 0 }}>
                ⚠️ Final Solution files have some Referencing Styles Errors
              </Title>
              <div>
                {Object.entries(majorminorReport)
                  .filter(([key]) => key === "major" || key === "minor")
                  .map(([key, value], index) => (
                    <Tag
                      key={index}
                      color={key === "major" ? "red" : "blue"}
                      style={{ fontSize: "16px" }}
                    >
                      <strong style={{ textTransform: "capitalize" }}>
                        {key}:
                      </strong>{" "}
                      {value}
                    </Tag>
                  ))}
              </div>
            </Flex>
          </Card>
        )}
      </>
    );
  };

  return (
    <div>
      <MyComponent majorminorReport={majorminorReport} />
      <h2>Are you sure to move this order for next step?</h2>
      {dataSource?.length > 0 && (
        <List
          dataSource={dataSource}
          renderItem={(item) => (
            <List.Item>
              <Checkbox
                checked={selectedUsers.includes(item.uuid)}
                onChange={() => handleUserSelect(item.uuid)}
              >
                {item.subscriber} ({item.type})
              </Checkbox>
            </List.Item>
          )}
        />
      )}

      <div style={{ marginTop: 16, textAlign: "right" }}>
        <Button
          loading={isSubmitLoading}
          type="primary"
          onClick={handleSubmitClick}
          style={{ color: "white" }}
          // disabled={selectedUsers.length === 0}
        >
          Submit
        </Button>
      </div>

      {/* Acknowledgement Modal for User Type 2 */}
      <Modal
        title="Declaration of Authenticity"
        open={showAcknowledgementModal}
        onCancel={() => setShowAcknowledgementModal(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => setShowAcknowledgementModal(false)}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!isAcknowledged}
            loading={isSubmitLoading}
            onClick={handleAcknowledgementSubmit}
          >
            Confirm & Submit
          </Button>,
        ]}
      >
        <div style={{ padding: "16px 0" }}>
          <Checkbox
            checked={isAcknowledged}
            onChange={(e) => setIsAcknowledged(e.target.checked)}
          >
            <span style={{ fontSize: "14px", lineHeight: "1.6" }}>
              I, as the assigned expert, confirm that I have personally
              completed this entire task. I have followed all provided
              guidelines accurately, have not used any AI tools at any stage of
              the work, and I take full responsibility for the authenticity and
              quality of the work submitted.
            </span>
          </Checkbox>
        </div>
      </Modal>
    </div>
  );
}

export default MarkAsComplete;
